import { Record } from 'immutable';

const BodyStyleRecord = Record({
    type: '',
    value: '',
    label: '',
    selected: false,
    codes: [],
    priority: 0,
});

class BodyStyle extends BodyStyleRecord {}

export default BodyStyle;
